import { render, staticRenderFns } from "./company-team.vue?vue&type=template&id=0ec1ca58&scoped=true&"
import script from "./company-team.vue?vue&type=script&lang=js&"
export * from "./company-team.vue?vue&type=script&lang=js&"
import style0 from "./company-team.vue?vue&type=style&index=0&id=0ec1ca58&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1ca58",
  null
  
)

export default component.exports